import React, { Fragment, useState, useRef, useEffect } from 'react';
import { t } from 'i18next';
import {
  Card,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Container,
  Modal,
} from 'react-bootstrap';
import { useNavigate, useParams, Link } from 'react-router-dom';
import ProgressBar from 'src/Member/components/progressbar/progressbar';
import {
  ErrorCircle,
  ProviderImageMen,
  ProviderImageUnknownGender,
  ProviderImageWomen,
  SuccessCircle,
  AccordionDownArrow,
  AccordionUpArrow,
  FacilityIcon,
} from 'src/Member/img/findcare/FindCareSVG';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import GeneralMessage from '../../components/GeneralMessage/GeneralMessage';
import { ConfigurationSVG } from '../../../../../Admin/img/GlobalSVG';
import { showNetworkName } from '../../../../utils/common';
import { formatDoctorName, findPercentage } from 'src/Member/utils/common';
import './FinalResultTile.scss';
import { useSelector } from 'react-redux';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
const AcceptingNewPatientsChip = ({ variant }) => {
  return (
    <span className={`accept-new-patient-${variant} d-block`}>
      <div className="d-flex align-items-center">
        {variant === 'success' && <SuccessCircle className="success-circle" />}
        {variant === 'danger' && <ErrorCircle className="danger-circle" />}
        <span>{t('find_provider.accepting_new_patients')}</span>
      </div>
    </span>
  );
};

const FinalResultTile = ({ data, index, paramsData }) => {
  const disclaimerRef = useRef();

  const disclaimerHeaderRef = useRef(null);
  const disclaimerTitleRef = useRef(null);
  const disclaimerContentRef = useRef(null);
  const disclaimerFooterRef = useRef(null);
  const { id } = useParams();
  const { searchParamsForUI, networkTierList } = useSelector(
    (state) => state?.priceCompare,
  );
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );
  const { Provider } = allFilters;
  const isExternalProvider = paramsData.networksData?.ProviderDirectory === 'R';
  console.log('isExternalProvider', isExternalProvider);
  const {
    Display_Network_Indicator_for_Price_Comparison_page,
    Value_Network_For_PriceComparison_Member,
    Display_Network_For_PriceComparison_Member,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);
  const { Find_Provider_Network } = useSelector(
    (state) => state?.app?.customNetwork,
  );
  const noDataMessage = t('find_provider.data_not_available');
  const inNetworkList = [];
  const addressZip = useSelector(
    (state) => state?.priceCompare?.searchParamsForUI?.locationData,
  );
  const [isActive, setIsActive] = useState(false);
  const [isOpenDisclaimerPopup, setisOpenDisclaimerPopup] = useState(false);
  const [showMoreDisclaimerButton, setShowMoreDisclaimerButton] =
    useState(false);
  if (Value_Network_For_PriceComparison_Member === 'network') {
    if (data.InNetwork === true && data?.DoctorNetworks?.length > 0) {
      data.DoctorNetworks.forEach((eachNetwork) => {
        if (
          networkTierList.findIndex((ele) => ele.value === eachNetwork) !== -1
        ) {
          inNetworkList.push(eachNetwork);
        }
      });
    }
  }

  let uniqueTier = [];
  if (Value_Network_For_PriceComparison_Member === 'tier') {
    const tierArr = [];
    if (data.DoctorNetworks?.length > 0) {
      networkTierList.forEach((eachNetwork) => {
        if (
          data.DoctorNetworks.findIndex(
            (ele) => ele === eachNetwork.NetworkDescription,
          ) !== -1
        ) {
          tierArr.push(eachNetwork.NetworkTier);
        }
      });
      uniqueTier = [...new Set(tierArr)];
      uniqueTier.sort();
    }
  }
  const onToggleClickHandler = () => {
    setIsActive(!isActive);
  };
  const serachNetworksFor = searchParamsForUI?.networksData || {
    label: 'All Plan Networks',
    value: 'All Plan Networks',
  };
  const InNetworkChip = ({ variant }) => {
    return (
      <span className={`in-network-${variant} d-block`}>
        <div className="d-flex align-items-center">
          {variant === 'success' && (
            <SuccessCircle className="success-circle" />
          )}
          {variant === 'danger' && <ErrorCircle className="danger-circle" />}
          <span>
            {variant === 'success'
              ? t('member.price_comparison.finalResultTile.in_network_label')
              : t(
                  'member.price_comparison.finalResultTile.out_of_network_label',
                )}
          </span>
        </div>
      </span>
    );
  };
  const CoverageFormat = (coverage) => {
    if (coverage) {
      const data = coverage.toString().replace(/,/g, '');
      return formatter.format(data);
    } else {
      return formatter.format(coverage);
    }
  };
  const handleClose = () => {
    setisOpenDisclaimerPopup(false);
  };

  useEffect(() => {
    if (disclaimerRef && disclaimerRef.current) {
      if (
        disclaimerRef?.current?.offsetWidth <
        disclaimerRef?.current?.scrollWidth
      ) {
        setShowMoreDisclaimerButton(true);
      } else {
        setShowMoreDisclaimerButton(false);
      }
    }
  }, [disclaimerRef]);

  useEffect(() => {
    if (isOpenDisclaimerPopup) {
      disclaimerTitleRef && disclaimerTitleRef?.current?.focus();
      setTimeout(() => {
        disclaimerHeaderRef &&
          disclaimerHeaderRef?.current?.removeAttribute('aria-hidden');
        disclaimerContentRef &&
          disclaimerContentRef?.current?.removeAttribute('aria-hidden');
        disclaimerFooterRef &&
          disclaimerFooterRef?.current?.removeAttribute('aria-hidden');
      }, 1000);
    }
  }, [isOpenDisclaimerPopup]);

  console.log(
    'data FinalResultTile',
    data,
    data.ClaimData,
    data.ClaimData.length > 0,
  );

  console.log('HERE data.ClaimData', !data.ClaimData.length);

  return (
    <Fragment key={index}>
      <div className="final-result-tile-container">
        <Card className="provider-details-card" role="rowgroup">
          <Row
            className={`profile-primary-info p-0 m-0 align-items-center justify-content-between ${
              !isActive && 'paddTop10'
            } `}
            role="row"
          >
            <Col lg={6} md={6} xs={11} className="p-0 m-0" role="cell">
              <div className="d-flex align-items-center no-flex-mobile">
                {data?.Provider === 'facility' ? (
                  <FacilityIcon
                    className="image-color"
                    circleClassName="circle-color"
                  />
                ) : (
                  <>
                    {data?.Gender === 'Female' && (
                      <ProviderImageWomen
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                    {data?.Gender === 'Male' && (
                      <ProviderImageMen
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                    {(!data?.Gender || data?.Gender?.trim() === 'Unknown') && (
                      <ProviderImageUnknownGender
                        className="image-color"
                        circleClassName="circle-color"
                      />
                    )}
                  </>
                )}
                <div className="ml-3 doctor-details-container">
                  {data?.ProviderName?.length > 22 ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 200, hide: 450 }}
                      overlay={
                        <Popover>
                          <Popover.Content>
                            <div className="tooltip-header">
                              {data?.ProviderName}
                            </div>
                          </Popover.Content>
                        </Popover>
                      }
                    >
                      <p
                        className="m-0 provider-name"
                        id={`provider-name-${data?.PhysicianID}`}
                      >
                        {data?.Provider === 'facility' ? (
                          isExternalProvider ? (
                            data?.ProviderName
                          ) : (
                            <Link
                              to={`/member/price-compare/facility-details/${data.PhysicianID}/${data?.Address?.PostalCode}`}
                              state={{
                                memberType:
                                  paramsData?.procedureForData.memberType,
                                memberOid: paramsData?.procedureForData.value,
                              }}
                            >
                              {data?.ProviderName}
                            </Link>
                          )
                        ) : isExternalProvider ? (
                          data?.ProviderName
                        ) : (
                          <Link
                            to={`/member/price-compare/doctor-details/${data.PhysicianID}/${data?.Address?.PostalCode}`}
                          >
                            {data?.ProviderName}
                          </Link>
                        )}
                      </p>
                    </OverlayTrigger>
                  ) : (
                    <p
                      className="m-0 provider-name"
                      id={`provider-name-${data?.PhysicianID}`}
                    >
                      {data?.Provider === 'facility' ? (
                        isExternalProvider ? (
                          data?.ProviderName
                        ) : (
                          <Link
                            to={`/member/price-compare/facility-details/${data.PhysicianID}/${data?.Address?.PostalCode}`}
                            state={{
                              memberType:
                                paramsData?.procedureForData.memberType,
                              memberOid: paramsData?.procedureForData.value,
                            }}
                          >
                            {data?.ProviderName}
                          </Link>
                        )
                      ) : isExternalProvider ? (
                        data?.ProviderName
                      ) : (
                        <Link
                          to={`/member/price-compare/doctor-details/${data.PhysicianID}/${data?.Address?.PostalCode}`}
                        >
                          {data?.ProviderName}
                        </Link>
                      )}
                    </p>
                  )}
                  <p className="m-0 provider-spacality">
                    {/*#TODO: experience is not available in JV as per story 357  {18 years in Practice |}  */}
                    {data.YearInPractice &&
                      `${data.YearInPractice} in Practice |`}{' '}
                    {data.Specialty && data.Specialty.join(', ')}
                  </p>
                  {data.ShowNetwork === true && (
                    <div className="section-networks network-hide-handler">
                      {Display_Network_Indicator_for_Price_Comparison_page ? (
                        data.InNetwork === true ? (
                          <InNetworkChip variant="success" />
                        ) : (
                          <InNetworkChip variant="danger" />
                        )
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                  <p className="provider-get-driections d-block d-md-none mt-3 mt-md-0">
                    {/*<span>Get Directions</span>  */}
                    {
                      data?.Address?.Coordinateds && (
                        //<Link
                        //to={{
                        //pathname: `https://www.google.com/maps/dir/?api=1&origin=${address}&destination=${data.Address.Coordinateds}`
                        //}}
                        //target="_blank">
                        <span className="secondary-2">
                          {t('member.price_comparison.result_card_distance')}
                        </span>
                      )
                      //</Link>
                    }
                    <br />
                    <span className="distance-count">
                      {data?.Distance &&
                        `${data?.Distance} mile${
                          Number(data?.Distance) > 1 ? 's' : ''
                        }`}
                    </span>
                  </p>
                </div>
              </div>
            </Col>
            <Col
              //md={isAccordion ? 4 : 4}
              //xs={isAccordion ? 11 : 12}
              className="m-0 p-0 d-flex justify-content-end align-items-center"
              role="cell"
            >
              {data.ShowNetwork === true && (
                <div className="section-networks">
                  {Display_Network_Indicator_for_Price_Comparison_page ? (
                    data.InNetwork === true ? (
                      <InNetworkChip variant="success" />
                    ) : (
                      <InNetworkChip variant="danger" />
                    )
                  ) : (
                    ''
                  )}
                </div>
              )}
              {data.ClaimData &&
                !data.ClaimData.length &&
                !data?.ClaimData[0]?.Error && (
                  <div className="provider-get-driections mt-3 mt-md-0 pr-3">
                    {data?.Address?.Coordinateds && (
                      <span className="secondary-2">
                        {t('member.price_comparison.result_card_distance')}
                      </span>
                    )}
                    <br />
                    <span className="distance-count">
                      {data?.Distance &&
                        `${data?.Distance} mile${
                          Number(data?.Distance) > 1 ? 's' : ''
                        }`}
                    </span>
                  </div>
                )}
              {data.ClaimData &&
                !data.ClaimData.length &&
                !data?.ClaimData[0]?.Error && (
                  <div
                    className="tabContainer pr-2"
                    role="button"
                    tabIndex={0}
                    onClick={() => onToggleClickHandler()}
                    aria-expanded={isActive}
                    id={index}
                    aria-controls={`section-${index}`}
                    aria-label={
                      isActive
                        ? 'Opened the Provider Details Panel'
                        : 'Closed the Provider Details Panel'
                    }
                  >
                    <span className="sr-only">
                      Details of {data?.ProviderName} provider details
                    </span>
                    <span className="tab">
                      {isActive ? (
                        <AccordionUpArrow className="acc-tab" />
                      ) : (
                        <AccordionDownArrow className="acc-tab" />
                      )}
                    </span>
                  </div>
                )}
            </Col>
            {data.ClaimData &&
              !data.ClaimData.length &&
              !data?.ClaimData[0]?.Error && (
                <Col
                  //md={isAccordion ? 2 : 3}
                  //xs={isAccordion ? 11 : 12}
                  className="py-2 pr-2 m-0 border-left d-flex align-items-stretch justify-content-center coverage-cell"
                  role="cell"
                >
                  <span className="sr-only">details of cost section</span>
                  <div className="cost-section pb-2 pt-1">
                    <>
                      {isExternalProvider && data?.Rate ? (
                        <div className="covered-cost">
                          <p className="title m-0 text-center">Covered Cost</p>
                          <p className="m-0 text-center value">
                            {/*{CoverageFormat(data?.ClaimData?.Covered)} */}
                            {CoverageFormat(data?.Rate)}
                          </p>
                        </div>
                      ) : (
                        data?.ClaimData?.Covered && (
                          <div className="d-block mt-1 patient_responsibility covered-cost">
                            <p className="title m-0 text-center">
                              Covered Cost
                            </p>
                            <p className="m-0 text-center value">
                              {CoverageFormat(data?.ClaimData?.Covered)}
                            </p>
                          </div>
                        )
                      )}
                      <div className="covered-cost ">
                        <p className="title m-0 text-center">
                          Patient Responsibility
                        </p>
                        <p className="m-0 text-center value">
                          {CoverageFormat(data?.ClaimData?.YouMayOwe)}
                        </p>
                      </div>
                    </>
                  </div>
                </Col>
              )}
          </Row>
          <Row
            tabIndex={0}
            role={'region'}
            className={`profile-seconday-info  ${'accordion-content'} ${'accordion-content-open'}`}
            id={`section-cost${index}`}
            aria-labelledby={index}
          >
            <div
              role="row"
              className={`d-flex flex-adjuster w-100 ${'padTop'} ${'padTop'} ${'row-item'}`}
            >
              {data.ClaimData &&
              data.ClaimData.length > 0 &&
              data.ClaimData[0].Error &&
              data.ClaimData[0].Error !== '' ? (
                <GeneralMessage
                  message={
                    data.ClaimData[0].Error ||
                    'Your request is in progress! You can navigate to Recent Request later to view your Estimates.'
                  }
                />
              ) : (
                <div role="cell" className="cost-details col pb-3 pb-md-0">
                  <div className="count-details-container">
                    <div className="left-container">
                      <div className="container-heading">
                        {t(
                          'member.price_comparison.finalResultTile.pricing_details',
                        )}
                      </div>
                      <div
                        className="count-details-main-wrapper"
                        role="section"
                      >
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.plan_pay',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.plan_pay',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(data?.ClaimData?.PlanPay)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          {/*Disallowed removing based on Navin Comment on JMP-8964 */}
                          {/*<span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.disallowed',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.disallowed',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(
                              data?.ClaimData?.Disallowed -
                                data?.ClaimData?.Copay -
                                (data?.ClaimData?.YouMayOwe -
                                  data?.ClaimData?.Copay -
                                  data?.ClaimData?.CoInsurance -
                                  data?.ClaimData?.Deductible),
                            )}
                          </span> */}
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.deductible',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.deductible',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(data?.ClaimData?.Deductible)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.copay',
                            )}
                          >
                            {t('member.price_comparison.finalResultTile.copay')}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(data?.ClaimData?.Copay)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          {/*<span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.deductible',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.deductible',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(data?.ClaimData?.Deductible)}
                          </span> */}
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.deductibleRemaining',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.deductibleRemaining',
                            )}
                          </span>
                          <span className="data-value">
                            {`${CoverageFormat(
                              data?.ClaimData?.NetIndDedMet,
                            )}/${CoverageFormat(
                              Number(data?.ClaimData?.NetIndDedMax) -
                                Number(data?.ClaimData?.NetIndDedMet),
                            )}`}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.co_insurance',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.co_insurance',
                            )}
                          </span>
                          <span className="data-value">
                            {' '}
                            {CoverageFormat(data?.ClaimData?.CoInsurance)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.other',
                            )}
                          >
                            {t('member.price_comparison.finalResultTile.other')}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(data?.ClaimData?.Other)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="right-container">
                      <div className="container-heading">
                        {t(
                          'member.price_comparison.finalResultTile.out_of_pocket',
                        )}
                      </div>
                      <div className="sr-only" id="accessibility-progressbar">
                        {data?.rightSideData?.OutOfPocket}% completed out of
                        100%
                      </div>
                      <div aria-describedby="accessibility-progressbar">
                        <ProgressBar
                          completed={findPercentage(
                            data?.ClaimData?.NetIndOOPMet,
                            data?.ClaimData?.NetIndOOPMax,
                          )}
                        />
                      </div>
                      <div
                        className="count-details-main-wrapper"
                        role="section"
                      >
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.applied',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.applied',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(data?.ClaimData?.NetIndOOPMet)}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.remaining',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.remaining',
                            )}{' '}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(
                              data?.ClaimData?.NetIndOOPMax -
                                data?.ClaimData?.NetIndOOPMet >
                                0
                                ? data?.ClaimData?.NetIndOOPMax -
                                    data?.ClaimData?.NetIndOOPMet
                                : 0,
                            )}
                          </span>
                        </div>
                        <div className="detils-wrapper">
                          <span
                            className="data-heading"
                            role="sectionhead"
                            aria-label={t(
                              'member.price_comparison.finalResultTile.maximum',
                            )}
                          >
                            {t(
                              'member.price_comparison.finalResultTile.maximum',
                            )}
                          </span>
                          <span className="data-value">
                            {CoverageFormat(data?.ClaimData?.NetIndOOPMax)}
                          </span>
                        </div>
                      </div>
                    </div>
                    {data?.Disclaimer && (
                      <div className="d-flex gap-3 align-items-center mt-2">
                        <div className="disclaimer-svg">
                          <ConfigurationSVG.WarningSVG />
                        </div>
                        <div className="warning-content mt-1 ml-2">
                          <GenericButton
                            variant="link"
                            className="viewmore-btn p-0 generic-button-disclaimer"
                            onClick={() => {
                              setisOpenDisclaimerPopup(!isOpenDisclaimerPopup);
                            }}
                            ariaLabel="Click to open disclaimer panel."
                          >
                            Disclaimer
                          </GenericButton>
                          {/*<span className="content-bold">Disclaimer: {''}</span>
                          <span className="disclaimer-text" ref={disclaimerRef}>
                            {' '}
                            {data.Disclaimer}
                          </span>
                          {showMoreDisclaimerButton && (
                            <span
                              className="button-position"
                              aria-hidden={true}
                            >
                              <GenericButton
                                variant="link"
                                className="viewmore-btn"
                                onClick={() => {
                                  setisOpenDisclaimerPopup(
                                    !isOpenDisclaimerPopup,
                                  );
                                }}
                              >
                                View More
                              </GenericButton>
                            </span>
                          )}*/}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </Row>
          <Row
            tabIndex={0}
            role={'region'}
            className={`profile-seconday-info  ${'accordion-content'} ${
              isActive && 'accordion-content-open'
            }`}
            id={`section-${index}`}
            aria-labelledby={index}
            aria-label={
              isActive
                ? 'Opened the Provider Details Panel'
                : 'Closed the Provider Details Panel'
            }
          >
            <div
              role="row"
              className={`d-flex flex-adjuster w-100 ${
                !!isActive && 'padTop'
              } ${isActive && 'padTop'} ${'row-item'}`}
            >
              <div
                role="cell"
                className="col-xs-12 border-right-info col-md-4 pb-3 pb-md-0"
              >
                <div className="provider-location-info">
                  {data?.Provider !== 'facility' && (
                    <p className="provider-location-data">
                      {!data?.Gender || data.Gender === 'Unknown'
                        ? 'N/A (Gender)'
                        : `${data?.Gender} (Gender)`}{' '}
                      {data?.YearInPractice
                        ? ` | ${data?.YearInPractice} years in Practice`
                        : ''}
                    </p>
                  )}
                  <p className="provider-location-data">
                    {data?.Address?.AddressLine1 &&
                      `${data?.Address?.AddressLine1}, `}
                    {data?.Address?.AddressLine2 &&
                      `${data?.Address?.AddressLine2}, `}
                    {data?.Address?.AddressLine3 &&
                      `${data?.Address?.AddressLine3}, `}
                    {data?.Address?.City && `${data?.Address?.City}, `}
                    {data?.Address?.County && `${data?.Address?.County}, `}
                    {data?.Address?.State && `${data?.Address?.State}, `}
                    {data?.Address?.PostalCode &&
                      `${data?.Address?.PostalCode}`}
                  </p>
                  <p className="provider-contact-data">
                    {data?.Address?.Phone1
                      ? data?.Address?.Phone1
                      : data?.Address?.Phone2
                      ? data?.Address?.Phone2
                      : noDataMessage}
                  </p>
                </div>
              </div>
              {data?.Provider !== 'facility' && (
                <div
                  role="cell"
                  className="col-md-3 col-xs-12 border-right-info pb-3 pb-md-0"
                >
                  <div className="section-networks">
                    <div className="mt-3">
                      {data.AcceptingNewPatients === true ? (
                        <AcceptingNewPatientsChip variant="success" />
                      ) : (
                        <AcceptingNewPatientsChip variant="danger" />
                      )}
                      <div className="provider-languages-info mt-3">
                        <p className="provider-language-heading">
                          {t('find_provider.language_spoken')}
                        </p>
                        <p className="provider-languages-data">
                          {data?.SpokenLanguages?.length > 0
                            ? data?.SpokenLanguages?.join(', ')
                            : noDataMessage}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div role="cell" className="col-xs-12 col-md-5 mt-3 mt-md-0">
                {data.InNetwork === true &&
                  Display_Network_For_PriceComparison_Member && (
                    <div>
                      <p className="provider-contact-heading m-0 p-0">
                        {Value_Network_For_PriceComparison_Member === 'tier' &&
                        uniqueTier?.length > 0
                          ? t(
                              'member.price_comparison.provider_container.networks_dropdown_labelTier',
                            )
                          : Value_Network_For_PriceComparison_Member ===
                              'network' && inNetworkList?.length > 0
                          ? t(
                              'member.price_comparison.provider_container.networks_dropdown_label',
                            )
                          : ''}
                      </p>
                      <div className="networks-list">
                        {Value_Network_For_PriceComparison_Member ===
                          'network' && (
                          <>
                            {inNetworkList?.length > 0 &&
                              data.InNetwork === true && (
                                <>
                                  {inNetworkList
                                    ?.slice(0, 2)
                                    .map((networkName, index) => {
                                      return (
                                        <React.Fragment
                                          key={`${networkName} ${index}`}
                                        >
                                          {serachNetworksFor?.value ===
                                          networkName ? (
                                            <span className="d-flex align-items-start">
                                              <span className="network-success">
                                                <SuccessCircle className="success-circle" />
                                              </span>
                                              <span className="ml-2">
                                                <span className="provider-contact-heading">
                                                  {showNetworkName(
                                                    Find_Provider_Network,
                                                    networkName,
                                                  )}
                                                  {inNetworkList?.indexOf(
                                                    networkName,
                                                  ) !==
                                                  inNetworkList?.length - 1
                                                    ? ','
                                                    : ''}
                                                </span>
                                              </span>
                                            </span>
                                          ) : (
                                            <span className="provider-contact-data mt-1 mb-1">
                                              {showNetworkName(
                                                Find_Provider_Network,
                                                networkName,
                                              )}
                                              {inNetworkList?.indexOf(
                                                networkName,
                                              ) !==
                                              inNetworkList?.length - 1
                                                ? ','
                                                : ''}
                                            </span>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  {inNetworkList?.length > 2 && (
                                    <span className="secondary-2 provider-contact-data">
                                      {data?.Provider === 'facility' ? (
                                        <Link
                                          to={`/member/price-compare/facility-details/${data?.PhysicianID}/${data?.Address?.PostalCode}`}
                                          state={{
                                            memberType:
                                              paramsData?.procedureForData
                                                .memberType,
                                            memberOid:
                                              paramsData?.procedureForData
                                                .value,
                                          }}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{inNetworkList?.length - 2}{' '}
                                            {t('find_provider.networks')}
                                          </span>
                                        </Link>
                                      ) : (
                                        <Link
                                          to={`/member/price-compare/doctor-details/${data?.PhysicianID}/${data?.Address?.PostalCode}`}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{inNetworkList?.length - 2}{' '}
                                            {t('find_provider.networks')}
                                          </span>
                                        </Link>
                                      )}
                                    </span>
                                  )}
                                </>
                              )}
                          </>
                        )}
                        {Value_Network_For_PriceComparison_Member ===
                          'tier' && (
                          <>
                            {uniqueTier?.length > 0 &&
                              data.InNetwork === true && (
                                <>
                                  {uniqueTier
                                    ?.slice(0, 2)
                                    .map((networkName, index) => {
                                      return (
                                        <React.Fragment
                                          key={`${networkName} ${index}`}
                                        >
                                          {serachNetworksFor?.label ===
                                          networkName ? (
                                            <span className="d-flex align-items-start">
                                              <span className="network-success">
                                                <SuccessCircle className="success-circle" />
                                              </span>
                                              <span className="ml-2">
                                                <span className="provider-contact-heading">
                                                  {networkName}
                                                </span>
                                              </span>
                                            </span>
                                          ) : (
                                            <span className="provider-contact-data mt-1 mb-1">
                                              {networkName}
                                            </span>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  {uniqueTier?.length > 2 && (
                                    <span className="secondary-2 provider-contact-data">
                                      {data?.Provider === 'facility' ? (
                                        <Link
                                          to={`/member/price-compare/facility-details/${data?.PhysicianID}/${data?.Address?.PostalCode}`}
                                          state={{
                                            memberType:
                                              paramsData?.procedureForData
                                                .memberType,
                                            memberOid:
                                              paramsData?.procedureForData
                                                .value,
                                          }}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{uniqueTier?.length - 2}{' '}
                                            {Value_Network_For_PriceComparison_Member ===
                                            'tier'
                                              ? t(
                                                  'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                                )
                                              : t(
                                                  'member.price_comparison.provider_container.networks_dropdown_label',
                                                )}
                                          </span>
                                        </Link>
                                      ) : (
                                        <Link
                                          to={`/member/price-compare/doctor-details/${data?.PhysicianID}/${data?.Address?.PostalCode}`}
                                        >
                                          <span className="secondary-2 cursor-pointer">
                                            +{uniqueTier?.length - 2}{' '}
                                            {Value_Network_For_PriceComparison_Member ===
                                            'tier'
                                              ? t(
                                                  'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                                )
                                              : t(
                                                  'member.price_comparison.provider_container.networks_dropdown_label',
                                                )}
                                          </span>
                                        </Link>
                                      )}
                                    </span>
                                  )}
                                </>
                              )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </Row>
        </Card>
      </div>
      {isOpenDisclaimerPopup && (
        <div>
          <Modal
            show={isOpenDisclaimerPopup}
            onHide={handleClose}
            centered
            className={`Right-Model member generic-model`}
          >
            <Modal.Header closeButton className="plandocument-header">
              <Container
                className="px-0"
                aria-hidden={true}
                ref={disclaimerHeaderRef}
              >
                <Row className="align-items-center p-0 m-0">
                  <Col className="px-0" ref={disclaimerTitleRef} tabIndex={-1}>
                    <Modal.Title>
                      Disclaimer<span className="sr-only"> Panel Opened</span>
                    </Modal.Title>
                  </Col>
                </Row>
              </Container>
            </Modal.Header>

            <Modal.Body className="disclaimer-body">
              <Container
                className="px-0 custom-scroller modal-content-container pl-4 disclaimer-modal-container"
                aria-hidden={true}
                ref={disclaimerContentRef}
              >
                <div
                  className="warning-content"
                  dangerouslySetInnerHTML={{
                    __html: data?.Disclaimer?.trim(),
                  }}
                />
              </Container>
            </Modal.Body>

            <Modal.Footer
              className="admin bg-white footer-class disclaimer-footer-btn"
              aria-hidden={true}
              ref={disclaimerFooterRef}
            >
              <div className="model-footer-btn txt-right p-0 m-0 border-0">
                {/*<GenericButton
                  className="p-0 m-0"
                  onClick={() => handleClose()}
                >
                  {t('label_cancel')}
                </GenericButton> */}
                <button onClick={() => handleClose()} className="close-btn">
                  Close
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </Fragment>
  );
};

export default FinalResultTile;
